import React from "react";
import {
  AppstoreAddOutlined,
  GlobalOutlined,
  HomeOutlined,
  MessageOutlined,
  OrderedListOutlined,
  ProfileOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";

const menu = [
  {
    label: <a href="/dashboard">Dashboard</a>,
    icon: <HomeOutlined />,
  },
  {
    label: <a href="/products">Products</a>,
    icon: <ProfileOutlined />,
  },
  {
    label: <a href="/categories">Category</a>,
    icon: <ProfileOutlined />,
  },
  {
    label: <a href="/orders">Orders</a>,
    icon: <OrderedListOutlined />,
  },
  {
    label: <a href="/customers">Customers</a>,
    icon: <UsergroupAddOutlined />,
  },
  {
    label: <a href="/store">Store Setting</a>,
    icon: <AppstoreAddOutlined />,
  },
  {
    label: <a href="/website">Website Information</a>,
    icon: <GlobalOutlined />,
  },
  {
    label: <a href="/contact">Website Contact</a>,
    icon: <MessageOutlined />,
  },
];

const superAdminmenu = [
  { label: <a href="/dashboard">Dashboard</a>, icon: <HomeOutlined /> },
  { label: <a href="/stores">All Stores</a>, icon: <ProfileOutlined /> },
];

const Sidebar = ({ superAdmin }) => {
  return (
    <Menu
      theme="light"
      defaultSelectedKeys={["1"]}
      mode="inline"
      items={superAdmin ? superAdminmenu : menu}
    />
  );
};

export default Sidebar;
